import { createFileRoute } from '@tanstack/react-router'
import { PasswordRecovery } from '@/components/password-recovery'

export const Route = createFileRoute('/reset-password')({
  component: () => <PasswordRecovery reset />,
})
